<div class="col-md-12">
  <div class="row mt-3 px-3">
    <div class="col-md-12 text-center">
      <h2 class="w-100">
        <strong> Mi Despertador </strong
        ><button
          id="abirModal"
          data-bs-toggle="modal"
          data-bs-target="#modalDespertador"
          class="offset-md-1 col-md-2 btn btn-sm btn-primary"
          (click)="new()"
        >
        <span>
          <i class="fas fa-plus"></i>
        </span>
      </button>
      </h2>
    </div>
  </div>
  <div class="row mt-3 px-3">
    <div
      class="row w-100 rowItem">
      <div class="col-md-12">
        <div class="row" *ngFor="let item of despertadores">
          <div class="col-md-3">
            <img
              src="../../assets/reloj.jpeg"
              height="100px"
              width="100px"
              alt=""
            />
          </div>
          <div class="col-md-7">
            <p>
              <strong>{{item.nombre}}</strong>
            </p>
            <p>{{item.hora}}</p>
            <p>{{item.del}} / {{item.al}}</p>
          </div>
          <div class="col-md-2 pt-4">
            <div class="row mt-2">
              <div class="col-md-12 text-warning" 
              data-bs-toggle="modal"
              data-bs-target="#modalDespertador"
              (click)="edit(item)">
                <span>
                  <i class="fas fa-edit"></i>
                </span>
              </div>
              <div class="col-md-12 text-danger" (click)="remove(item)">
                <span>
                  <i class="fas fa-trash"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <!---->
      </div>
    </div>
  </div>
</div>
<div
  
  id="modalDespertador"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  class="modal fade"
  style="display: none"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div  class="modal-content">
      <div  class="modal-header">
        <h3  id="exampleModalLabel" class="modal-title">
          {{(despertador.id==0)?'Nuevo':'Modificar'}} Despertador
        </h3>
      </div>
      <div  class="modal-body">
        <div  class="row">
          <div  class="col-md-12 mb-3">
            <label
              
              for="exampleFormControlInput1"
              class="form-label"
              >Nombre</label
            ><input
              [(ngModel)]="despertador.nombre"
              type="text"
              class="form-control ng-valid ng-dirty ng-touched"
            />
          </div>
          <div  class="col-md-12 mb-3">
            <label
              
              for="exampleFormControlInput1"
              class="form-label"
              >Del</label
            ><input
            [(ngModel)]="despertador.del"
              type="date"
              class="form-control ng-valid ng-dirty ng-touched"
            />
          </div>
          <div  class="col-md-12 mb-3">
            <label
              
              for="exampleFormControlInput1"
              class="form-label"
              >Al</label
            ><input
            [(ngModel)]="despertador.al"
              type="date"
              class="form-control ng-valid ng-dirty ng-touched"
            />
          </div>
          <div  class="col-md-12 mb-3">
            <label
            
              for="exampleFormControlInput1"
              class="form-label"
              >Hora </label
            ><input
            [(ngModel)]="despertador.hora"
              type="time"
              class="form-control ng-valid ng-dirty ng-touched"
            />
          </div>
        </div>
      </div>
      <div  class="modal-footer">
        <button
          
          type="button"
          id="btnCloseDespertador"
          data-bs-dismiss="modal"
          class="btn btn-secondary"
        >
          Cerrar</button
        ><button  type="button" class="btn btn-primary"
        (click)="guardar()"
        >
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>
